<template>
  <div class="dy">
    <el-upload
      ref="videoUpload"
      :action="hots"
      name="uploadVideo"
      :show-file-list="true"
      :before-upload="beforeUpload"
      :on-success="handleAvatarSuccess">
      <el-button size="small" type="primary">点击上传</el-button>
    </el-upload>
  </div>
</template>

<script>
  import config from '@/lib/http/config'
  import {Loading} from 'element-ui';

  export default {
    name: "videoUpload",
    props: {
      value: {},
      defaultUrl: {
        type: String,
        default: ''
      },
      returnUrl: {
        default: false
      }
    },
    data() {
      return {
        videoUrl: '',
        hots: '',
        loadingInstance: '',
      }
    },
    methods: {
      getHosts: () => {
        let host = document.location.protocol + '//' + window.location.host;
        if (host.indexOf('127') != -1 || host.indexOf('localhost') != -1) {
          host = config.baseURL;
        }
        return host + '/api/videoUpload';
      },
      beforeUpload() {
        this.loadingInstance = Loading.service({
          text: "上传中"
        })
      },
      handleAvatarSuccess(res) {
        this.loadingInstance.close();
        if (res.result.code == '1') {
          if (this.returnUrl) {
            this.$emit('input', res.url);
          } else {
            this.$emit('input', res.video);
          }
          this.videoUrl = res.url;
        } else {
          console.log('上传错误');
        }
      },
    },
    watch: {
      defaultUrl(value) {
        this.videoUrl = value;
      }
    },
    created() {
      this.videoUrl = this.defaultUrl;
      this.hots = this.getHosts();
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/video/VideoUpload.vue